/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Desktopblocksubtitle2Inputs */



/**
* | output |
* | --- |
* | "Please run it on a phone via Telegram" |
*
* @param {Desktopblocksubtitle2Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const desktopblocksubtitle2 = /** @type {((inputs?: Desktopblocksubtitle2Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Desktopblocksubtitle2Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Please run it on a phone via Telegram")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ábrelo en el móvil a través de Telegram")
	return /** @type {LocalizedString} */ ("Пожалуйста, открой с телефона через Telegram")
});
export { desktopblocksubtitle2 as "desktopBlockSubtitle" }